export const HANDOFF_INBOX_ENABLED = import.meta.env.VITE_HANDOFF_INBOX_ENABLED === 'true';
